/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveCryptoSwapRegistryFetcher,
  CurveCryptoSwapRegistryFetcherInterface,
  PoolStruct,
} from "../CurveCryptoSwapRegistryFetcher";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "_addressProvider",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isMeta",
            type: "bool",
          },
        ],
        internalType: "struct Pool[]",
        name: "_pools",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "AlreadyRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "CantResolvePoolInRegistry",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyAddressProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyPoolAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "PoolIsNotRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistryIsTheSame",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "enum RegistryId",
        name: "id",
        type: "uint8",
      },
    ],
    name: "RegistryNotFoundById",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ICurveAddressProviderLike",
        name: "curveAddressProvider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum RegistryId",
        name: "registryId",
        type: "uint8",
      },
    ],
    name: "DataFetcherCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "PoolAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "PoolRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "ADDRESS_PROVIDER",
    outputs: [
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTRY_ID",
    outputs: [
      {
        internalType: "enum RegistryId",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isMeta",
            type: "bool",
          },
        ],
        internalType: "struct Pool[]",
        name: "_pools",
        type: "tuple[]",
      },
    ],
    name: "addPools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensDetailsFetcherPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "registeredPools",
    outputs: [
      {
        internalType: "bool",
        name: "isRegistered",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isMeta",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "removePools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveCryptoSwapRegistryFetcherConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveCryptoSwapRegistryFetcherConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveCryptoSwapRegistryFetcher__factory extends ContractFactory {
  constructor(...args: CurveCryptoSwapRegistryFetcherConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveCryptoSwapRegistryFetcher";
  }

  deploy(
    _repository: string,
    _addressProvider: string,
    _pools: PoolStruct[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveCryptoSwapRegistryFetcher> {
    return super.deploy(
      _repository,
      _addressProvider,
      _pools,
      overrides || {}
    ) as Promise<CurveCryptoSwapRegistryFetcher>;
  }
  getDeployTransaction(
    _repository: string,
    _addressProvider: string,
    _pools: PoolStruct[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _addressProvider,
      _pools,
      overrides || {}
    );
  }
  attach(address: string): CurveCryptoSwapRegistryFetcher {
    return super.attach(address) as CurveCryptoSwapRegistryFetcher;
  }
  connect(signer: Signer): CurveCryptoSwapRegistryFetcher__factory {
    return super.connect(signer) as CurveCryptoSwapRegistryFetcher__factory;
  }
  static readonly contractName: "CurveCryptoSwapRegistryFetcher";
  public readonly contractName: "CurveCryptoSwapRegistryFetcher";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveCryptoSwapRegistryFetcherInterface {
    return new utils.Interface(_abi) as CurveCryptoSwapRegistryFetcherInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveCryptoSwapRegistryFetcher {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveCryptoSwapRegistryFetcher;
  }
}
